module.exports = require('./head');



//////////////////
// WEBPACK FOOTER
// ./~/recharts/~/lodash/first.js
// module id = ./node_modules/recharts/node_modules/lodash/first.js
// module chunks = 1